import React, { Component } from 'react';
import RegisterForm from './RegisterForm';
import RegisterOTP from './RegisterOTP';
import RegisterPassword from './RegisterPassword';
import '../css/Register.css';

const $ = window.$;

class Register extends Component {
    constructor() {
        super();
        this.state={ page: 1, timeOut: '', AccountID: 0 };
    }

    setPage = (page) => {
        this.setState({ page: page });
    }

    setTimeOTP = (time) => {
        this.setState({ timeOut: time });
    }

    setAccountID = (id) => {
        this.setState({ AccountID: id });
    }

    getView() {
        if ( this.state.page === 1 ) {
            $("#line-first").removeClass("line-active");
            $("#border-second").removeClass("cycle-active");
            $("#i-secode").removeClass("icon-active");
            $("#text-second").removeClass("text-active");
            return <RegisterForm Page={this.state.page} onSelectPage={this.setPage} onTimeOut={this.setTimeOTP} onAccountID={this.setAccountID} />
        } else if ( this.state.page === 2 ) {
            $("#line-first").addClass("line-active");
            $("#border-second").addClass("cycle-active");
            $("#i-secode").addClass("icon-active");
            $("#text-second").addClass("text-active");
            return <RegisterOTP Page={this.state.page} onSelectPage={this.setPage} timeOut={this.state.timeOut} AccountID={this.state.AccountID} />
        } else if ( this.state.page === 3 ) {
            $("#line-second").addClass("line-active");
            $("#border-third").addClass("cycle-active");
            $("#i-third").addClass("icon-active");
            $("#text-third").addClass("text-active");
            return <RegisterPassword AccountID={this.state.AccountID} />;
        }
    }

    render() {
        return (
            <div className="fix-content content-bar-bigger register-content">
                <table className="register-table">
                    <tbody>
                        <tr>
                            <td width="75px">
                                <div className="cycle cycle-active" id="border-first"><i className="fab fa-wpforms regis-icon icon-active" id="i-first"></i></div>
                            </td>
                            <td>
                                <div className="line" id="line-first"></div>
                            </td>
                            <td width="75px">
                                <div className="cycle" id="border-second"><i className="fas fa-mobile-alt regis-icon" id="i-secode"></i></div>
                            </td>
                            <td>
                                <div className="line" id="line-second"></div>
                            </td>
                            <td width="75px">
                                <div className="cycle" id="border-third"><i className="fas fa-key regis-icon" id="i-third"></i></div>
                            </td>
                        </tr>
                        <tr>
                            <td><span className="regis-text text-active" id="text-first">กรอกข้อมูล</span></td>
                            <td></td>
                            <td><span className="regis-text" id="text-second">รหัส OTP</span></td>
                            <td></td>
                            <td><span className="regis-text" id="text-third">ตั้งรหัสผ่าน</span></td>
                        </tr>
                    </tbody>
                </table>
                {this.getView()}
            </div>
        )
    }
}

export default Register;